import { jsx as _jsx } from "react/jsx-runtime";
import createSvgIcon from "./utils/createSvgIcon";
export default createSvgIcon(/*#__PURE__*/ _jsx("path", {
    fill: "currentColor",
    d: "M19 12.0025a1.313 1.313 0 0 1-1.3125 1.3125H6.3125a1.3127 1.3127 0 0 1-.928-2.2406 1.312 1.312 0 0 1 .928-.3844h11.375A1.313 1.313 0 0 1 19 12.0025M12 8.94c.9665 0 1.75-.7835 1.75-1.75S12.9665 5.44 12 5.44s-1.75.7835-1.75 1.75.7835 1.75 1.75 1.75m0 9.625c.9665 0 1.75-.7835 1.75-1.75s-.7835-1.75-1.75-1.75-1.75.7835-1.75 1.75.7835 1.75 1.75 1.75"
}), "Division", {
    "style": {
        "fill": "none"
    },
    "viewBox": "0 0 24 24"
});
